export class GenericBaseRequest {
  public versionAplicativo: string;
  public uuid: string;
  public version: String;
  public descripcion: String;
  public platform: number;
}
